import { Component, OnInit, ViewChild } from "@angular/core";
import { AlertController, ModalController, NavController, Platform, IonItemSliding } from "@ionic/angular";
import { AppModeService } from "src/app/angular-wallet-base/services/app-mode.service";
import { Store } from "@ngrx/store";
import { CoinGeckoService } from "../../../angular-wallet-base/services/coingecko.service";
import { Actions, ofType } from "@ngrx/effects";
import { takeUntil } from "rxjs/operators";
import { RawTransactionVerbose, TokenInfo, TransactionSummary, UnconfirmedTransaction } from "../../../global";
import { environment } from "src/environments/environment";
import { SmallToCryptoPipe } from "../../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.pipe";
import { getBaseCurrency } from "../../../angular-wallet-base/store/userPreferences";
import { AppState } from "../../../angular-wallet-base/store/appState";
import { SubscriptionListenerComponent } from "../../../angular-wallet-base/SubscriptionListenerComponent";
import { getTokenKeyring, getUnconfirmedTxs, getTokenKeyringPagedTransactions, getKeychain } from "../../../angular-wallet-base/store/wallet";
import {
  ChartComponent
} from "ng-apexcharts";
import {
  getTransactionMemo,
  getTokenFiatValue,
  handleCopy,
  getTransactionAmountsByAddress,
  getAuxFeeFromTx,
  removeAuxFeeAddressFromArray,
  getSendTypeValueFromtxAmount,
  getReceiveTypeValueFromtxAmount,
  getTransactionAmountsByAddressSol,
  presentAlert,
  openKycModal,
  getTokenInfoArray,
  getTransactionAmountsByEVMAddress,
  TxSummary,
} from "src/app/angular-wallet-base/utils";
import { TranslateService } from "@ngx-translate/core";
import { ClipboardService } from "ngx-clipboard";
import { Clipboard } from "@ionic-native/clipboard/ngx";
import { ActivatedRoute, Router, NavigationExtras } from "@angular/router";
import {
  GetTokenHistoryRequestAction,
  WalletActionTypes,
  GetTokenHistorySuccessAction,
} from "../../../angular-wallet-base/actions/wallet.actions";
import { take } from "rxjs/operators";
import { getSideMenuStatus } from "src/app/angular-wallet-base/store/appSettings";
import { SendAssetModal } from "../../send-asset-modal/send-asset-modal.component";
import { ReceiveAssetModal } from "../../receive-asset-modal/receive-asset-modal.component";
import { BigNumber } from "bignumber.js";
import * as moment from "moment";
import { CustomCurrencyPipe } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.pipe';
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';
import { ComplianceService } from "../../../angular-wallet-base/services/compliance.service";
import { Logger } from "src/app/angular-wallet-base/services/logger.service";
import { inspect } from "util";
import { GraphqlService } from "src/app/angular-wallet-base/services/graphql.service";
import { StorageService } from "src/app/angular-wallet-base/services/storage.service";
import { SelectPaymentModal } from "../../select-payment-modal/select-payment-modal";
import { GRAPH_DATA_OF_ALL_TOKENS, PRICE_LIST_OF_TOKENS } from "src/app/angular-wallet-base/constants";
import { GraphService } from "src/app/angular-wallet-base/services/graph.service";


@Component({
  selector: "app-prime-asset-page",
  templateUrl: "./prime-asset.component.html",
  styleUrls: ["./prime-asset.component.scss"],
})
export class PrimeAssetComponent extends SubscriptionListenerComponent implements OnInit {
  public isDesktopMode;
  address = "fhgjfasahsdfghdf34ghgs4ja5hjfjdsh";
  trimmedAddress;
  public unconfirmedTxs: UnconfirmedTransaction[] = [];
  transactionDetails = [
    { type: "Sent", address: "7KDg...hdYH", growth: "-1.5 AGX", iconName: "arrow-up-outline", amount: "1.13 USD", tran_nature: "out" },
    { type: "Purchased", address: "jtfs2...Uyg5", growth: "+1.5 AGX", amount: "3.13 USD", iconName: "cart-outline", tran_nature: "in" },
    {
      type: "Received",
      address: "fdJGH...Ggf6F",
      growth: "+0.05 AGX",
      amount: "2.15 USD",
      iconName: "download-outline",
      tran_nature: "in",
    },
    {
      type: "Received",
      address: "fdJGH...Ggf6F",
      growth: "+3.26 AGX",
      amount: "54.68 USD",
      iconName: "download-outline",
      tran_nature: "in",
    },
    { type: "Sent", address: "7KDg...hdYH", growth: "-0.05 AGX", iconName: "arrow-up-outline", amount: "0.013 USD", tran_nature: "out" },
    {
      type: "Received",
      address: "fdJGH...Ggf6F",
      growth: "+2.66 AGX",
      amount: "104.77 USD",
      iconName: "download-outline",
      tran_nature: "in",
    },
  ];
  //chart//

  @ViewChild("chart", { static: false }) chart: ChartComponent;
  @ViewChild("chartMarket", { static: false }) chartMarket: ChartComponent;

  public chartOptions;
  public chartMarketOptions;
  public vaultChartOptions;
  public vaultMarketChartOptions;
  public tradeChartOptions;
  public premiumChartOptions;
  public chartYAxis = [];
  public activeYAxis = 5;
  public showholdingChart = false;
  public showPriceChart = false;
  public waveSvg = "vault";
  public activeOptionButton = "ALL";
  public selectedDate = "";
  public updateOptionsData;
  public coinNature: string = "holdings";
  public asset: any;
  public transaction: any;
  public network: string;
  public viewData = [];
  private itemsPerPage = 10;
  public walletAddress;
  public currentBaseCurrency: any;
  private pageNumber = 1;
  public allDataLoaded = false;
  public canBuyAsset: boolean = false;
  public showLoader = false;
  public dataLoader = true;

  public coinList = ["SYS", "BTC", "ETH", "SOL", "USDC", "AVAX", "USDC.e", "WAVAX"];
  public buyList = ["AGX", "AUX", "LODE", "BTC", "ETH", "USDC", "AVAX"];
  public graphMarketPrice: any = [];
  public graphTempData: any = [];

  public timestampMap;
  public mapTransactionData;
  public tempDateTransaction;
  public priceDataCoin;
  public transactionDates: any = [];
  public transactiondateMap: any = {}
  public assetPriceDuration: any = 366;
  public graphDataSet;
  public pendingTx = []
  public updateTxHistory = false;
  public firstTimeexec = true;
  public marketHistoryCoin;
  public marketHistoryGrowth = { incurrency: 0, inpercentage: 0 };
  public growthPercentage: any = {
    percentage: 0,
    amount: 0
  };
  public priceHistoryList: any;
  constructor(
    protected store: Store<AppState>,
    private navCtrl: NavController,
    private appMode: AppModeService,
    private platform: Platform,
    public customcurrency: CustomCurrencyPipe,
    private clipboard: Clipboard,
    public alertController: AlertController,
    private smallToCryptoPipe: SmallToCryptoPipe,
    private translate: TranslateService,
    private clipboardService: ClipboardService,
    private route: ActivatedRoute,
    private router: Router,
    private actions$: Actions,
    public modalController: ModalController,
    private complianceService: ComplianceService,
    private coinGecko: CoinGeckoService,
    private authGuardService: AuthGuardService,
    private graphqlService: GraphqlService,
    private storage: StorageService,
    private graphService: GraphService
  ) {
    super(store);
    this.chartYAxis = this.graphService.chartYAxis.getValue();
    this.updateOptionsData = this.graphService.updateOptionsData.getValue();
    // fetching graph data after each transactions
    this.graphService.chartCount.subscribe((count) => {
      this.fetchStorageData();
      this.fetchPriceHistoryGraph();
    });
    var d = new Date();
    var pastYear = d.getFullYear() - 1;
    d.setFullYear(pastYear);
    this.timestampMap = d.getTime();
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
    this.coinNature = "holdings";
    this.trimmedAddress = this.address.substring(0, 4) + "..." + this.address.substring(25, this.address.length);
    const tabInstance = this;
    const tokenData = this.authGuardService.token;
    if (tokenData) {
      // dont use promise, as we need to listen for balance and transaction changes.
      this.subscriptions.add(this.store.select(getKeychain).subscribe(keychain => {
        const tokenInfoArray = getTokenInfoArray(keychain);
        const tokenAsset: Partial<TokenInfo> = tokenData['token'] || tokenData;
        const tokenInfo = tokenInfoArray.find(token =>
        ( token?.keyringId === tokenAsset?.keyringId ||
          token?.symbol === tokenAsset?.symbol &&
          token?.baseChainSymbol === tokenAsset?.baseChainSymbol &&
          token?.name === tokenAsset?.name && 
          token?.address === tokenAsset?.address
        ));
        this.asset = tokenInfo;
      }));
      this.transaction = tokenData['unconfirmedTxs'];
      this.canBuyAsset = (this.asset && this.buyList.includes(this.asset.symbol)) ? false : true;
      this.fetchTransaction();
    }
  }

  async fetchStorageData() {
    this.graphDataSet = await this.storage.get(GRAPH_DATA_OF_ALL_TOKENS);
    if (this.graphDataSet[this.asset.symbol + "-" + this.asset.baseChainSymbol] != undefined &&
      this.graphDataSet[this.asset.symbol + "-" + this.asset.baseChainSymbol].length > 0) {
      this.vaultChartOptions.series[0].data = this.graphDataSet[this.asset.symbol + "-" + this.asset.baseChainSymbol];
      this.showholdingChart = true;
      this.chartInit();
    } else {
      this.showholdingChart = false;
    }
    Logger.info('fetchStorageData',this.showholdingChart);
  }

  async fetchPriceHistoryGraph() {
    this.priceHistoryList = await this.graphService.getPriceHistoryData(this.currentBaseCurrency);
    if (this.priceHistoryList[this.asset.symbol] != undefined && this.priceHistoryList[this.asset.symbol].length > 0) {
      this.vaultMarketChartOptions.series[0].data = this.priceHistoryList[this.asset.symbol];
      this.showPriceChart = true;
      this.chartInit();
    } else {
      this.showPriceChart = false;
    }
    Logger.info('fetchPriceHistoryGraph',this.showPriceChart);

  }

  async getMarketPriceChange() {
    if (this.asset.coingeckoId) {
      await this.coinGecko.getCurrentDataTokens(this.asset.coingeckoId).then(async (data: any) => {
        this.marketHistoryCoin = data.market_data;
      });
    }
  }

  setGrowthPrices(currencyField) {
    try {
      const currentPrice = this.marketHistoryCoin
        ? this.marketHistoryCoin['current_price'][this.currentBaseCurrency.toLowerCase()].toFixed(2)
        : 0;
      const marketHistoryGrowth = this.marketHistoryCoin
        ? this.marketHistoryCoin[currencyField][this.currentBaseCurrency.toLowerCase()].toFixed(2)
        : 0;

      this.marketHistoryGrowth = {
        incurrency: Number((Number(currentPrice) * (Number(marketHistoryGrowth) / 100)).toFixed(2)),
        inpercentage: marketHistoryGrowth
      }
    }
    catch (err) {
      Logger.error('Currency percentage not available', err);
      this.marketHistoryGrowth = {
        incurrency: 0,
        inpercentage: 0
      };
    }

  }

  getAssetGrowth(timeRange) {
    switch (timeRange) {
      case '1D':
        this.setGrowthPrices('price_change_percentage_24h_in_currency')
        break;
      case '1W':
        this.setGrowthPrices('price_change_percentage_7d_in_currency')
        break;
      case '1M':
        this.setGrowthPrices('price_change_percentage_30d_in_currency')
        break;
      case 'YTD':
        this.setGrowthPrices('price_change_percentage_1y_in_currency')
        break;
      default:
        this.setGrowthPrices('price_change_percentage_1y_in_currency')
        break;
    }
  }




  assetSymbolParser() {
    if (this.asset.baseChainSymbol == "ETH") return "ethereum";
    if (this.asset.baseChainSymbol == "SOL") return "solana";
  }

  async ngOnInit() {
    this.vaultChartOptions = await this.graphService.getAssetPagechartOptions(this.isDesktopMode, this);
    this.vaultMarketChartOptions = await this.graphService.getAssetPageMarketChartOptions(this.isDesktopMode, this);
    this.currentBaseCurrency = await this.store.select(getBaseCurrency).pipe(take(1)).toPromise();
    this.initChart();
    await this.fetchTransaction();
    await this.getMarketPriceChange()

    this.allDataLoaded = false;
    this.subscriptions.add(
      this.store.select(getUnconfirmedTxs).subscribe((txs) => {
        const unconfirmedTxs: any = txs.filter((tx) => {
          return tx.tokenInfo.keyringId === this.asset.keyringId;
        });
        if (unconfirmedTxs && unconfirmedTxs.length) {
          this.pendingTx.push(unconfirmedTxs.txid);
          this.transactionListener();
          this.updateTxHistory = true;
        }
        unconfirmedTxs.reverse();
        this.decorateUnconfirmedTransactions(unconfirmedTxs);
      })
    );
  }

  chartInit() {
    this.updateOptions("ALL");
  }

  ionViewWillEnter() {
    this.allDataLoaded = false;
    this.fetchStorageData();
    this.fetchPriceHistoryGraph();
  }

  async getTokenHistory(page) {
    if (this.asset.baseChainSymbol === "HL") {
      return;
    }

    this.store.dispatch(
      new GetTokenHistoryRequestAction({
        sysGuid: this.asset.symbol === this.asset.baseChainSymbol ? null : this.asset.guid || this.asset.symbol,
        ethFilterIndex: this.asset.ethFilterIndex || null,
        address: this.asset.address,
        pageNum: page,
        itemsPerPage: this.itemsPerPage,
        baseChainSymbol: this.asset.baseChainSymbol,
      })
    );
  }

  async loadData(showAll = false) {
    this.showLoader = true;
    this.pageNumber += 1;

    let lastTx = null;
    if (this.asset.baseChainSymbol === "SOL") {
      lastTx = this.viewData[this.viewData.length - 1].txid;
      this.itemsPerPage = environment.SOLANA_HISTORY_LIMIT;
    }
    this.store.dispatch(
      new GetTokenHistoryRequestAction({
        ethFilterIndex: this.asset.ethFilterIndex || null,
        sysGuid: this.asset.symbol === this.asset.baseChainSymbol ? null : this.asset.guid || this.asset.symbol,
        address: this.asset.address,
        pageNum: lastTx !== null ? lastTx : this.pageNumber,
        itemsPerPage: showAll ? null : this.itemsPerPage,
        baseChainSymbol: this.asset.baseChainSymbol,
      })
    );

    this.actions$
      .pipe(ofType(WalletActionTypes.GET_TOKEN_HISTORY_SUCCESS), takeUntil(this.destroyed$))
      .subscribe((action: GetTokenHistorySuccessAction) => {
        this.handleAllDataLoaded(action);
      });
  }

  async handleAllDataLoaded(action: GetTokenHistorySuccessAction) {
    const transactions = await action.payload.result.transactions;
    if (this.viewData[this.viewData.length - 1]) {
      if (transactions[transactions.length - 1].txid === this.viewData[this.viewData.length - 1].txid) {
        this.allDataLoaded = true;
      } else if (!transactions) {
        this.allDataLoaded = true;
      } else {
        this.allDataLoaded = false;
      }
    }
    this.showLoader = false;
  }

  getTokenFiatValue(fiatRate, balance) {
    fiatRate = fiatRate ? fiatRate : 0;
    return getTokenFiatValue(fiatRate, balance);
  }
  getTokenBalanceOfToken(amount: any) {
    return this.smallToCryptoPipe.transform(amount, { type: this.asset.baseChainSymbol, precision: this.asset.precision });
  }

  async fetchTransaction() {
    this.dataLoader = true;
    this.walletAddress = await this.getWalletAddress();
    await this.getTokenHistory(1);
    await this.transactionListener();
  }

  transactionListener() {
    this.subscriptions.add(
      this.store.select(getTokenKeyringPagedTransactions, { keyringId: this.asset.keyringId }).subscribe(async (pagedTransactions) => {
        Logger.info(pagedTransactions);
        if (!pagedTransactions) {
          return;
        } else if (pagedTransactions.transactions[0] === undefined || pagedTransactions.transactions.length < this.itemsPerPage) {
          this.allDataLoaded = true;
        }

        this.viewData = [].concat(
          await this.decorateTransactions(
            // Just adding confirmed transactions
            pagedTransactions.transactions.filter((tx) => tx && tx.confirmations)
          )
        );
        if (this.updateTxHistory || !this.firstTimeexec) {
          // this.getFilteredMapDataSet();
        }

        this.dataLoader = false;
      })
    );
  }

  async getFilteredMapDataSet() {
    var assetTotalBalance = Number(this.asset.balance);
    this.mapTransactionData = this.viewData.map((obj) => {
      var dateTransaction = new Date(obj.blockTime * 1000).toString().substring(4, 15);
      if (obj.type == "receive") {
        assetTotalBalance = assetTotalBalance - Number(obj.amount);
        var formattedBalance = this.smallToCryptoPipe.transform(assetTotalBalance, { type: this.asset.baseChainSymbol });
        return [obj.time, formattedBalance, dateTransaction];
      } else {
        assetTotalBalance = assetTotalBalance + Number(obj.amount) + Number(obj.fee);
        var formattedBalance = this.smallToCryptoPipe.transform(assetTotalBalance, { type: this.asset.baseChainSymbol });
        return [obj.time, formattedBalance, dateTransaction];
      }
    });

    var filteredData = await this.mapTransactionData.filter(this.filterDuplicates.bind(this));

    var mapData = [];
    var mapDatatest = [];
    var coinCount = filteredData[filteredData.length - 1][1];
    for (let i = 0; i < this.priceDataCoin.length; i++) {

      if (this.transactiondateMap[this.priceDataCoin[i][2]] != undefined) {
        coinCount = this.transactiondateMap[this.priceDataCoin[i][2]][1];

      }
      let fiatValue = await this.getFiatValue(this.priceDataCoin[i][1], coinCount);
      mapData.push([this.priceDataCoin[i][0], Number(fiatValue), coinCount, this.priceDataCoin[i][2]]);
      mapDatatest.push([this.priceDataCoin[i][0], Number(fiatValue), this.priceDataCoin[i][2]]);
    }
    if (this.graphDataSet[this.asset.keyringId].length) {
      if (this.graphDataSet[this.asset.keyringId][this.graphDataSet.length - 1][3] == mapData[mapData.length - 1][3]) {
        this.graphDataSet[this.asset.keyringId][this.graphDataSet.length - 1] = mapData[mapData.length - 1];
        this.vaultChartOptions.series[0].data = this.graphDataSet[this.asset.keyringId];
        this.chartInit()
      } else if (this.graphDataSet[this.asset.keyringId][this.graphDataSet.length - 1][0] < mapData[mapData.length - 1][0]) {
        this.graphDataSet[this.asset.keyringId].push(mapData[mapData.length - 1])
        this.vaultChartOptions.series[0].data = this.graphDataSet[this.asset.keyringId];
        this.chartInit()
      }
      this.updateTxHistory = false;
      this.firstTimeexec = false;
    }
  }

  async formatMapData(filteredData) {
    for (let i = 0; i < this.priceDataCoin.length; i++) {
      if (!this.transactionDates.includes(this.priceDataCoin[i][2])) {
        filteredData.push(this.priceDataCoin[i]);
      }
    }
    await filteredData.sort(function (a, b) { return a[0] - b[0] });
    return filteredData;
  }

  async getFiatValue(fiatRate, balance) {
    var fiat = await new BigNumber(fiatRate).multipliedBy(new BigNumber(balance)).toFixed(2);
    return fiat;
  }

  filterDuplicates(obj) {
    var dateFormatted = new Date(obj[0] * 1000).toString().substring(4, 15);
    if (dateFormatted != this.tempDateTransaction) {
      this.tempDateTransaction = dateFormatted;
      this.transactionDates.push(dateFormatted);
      this.transactiondateMap[obj[2]] = [obj[0], obj[1]]
      return true;
    }
  }

  initChart() {
    this.chartOptions = this.vaultChartOptions;
    this.chartMarketOptions = this.vaultMarketChartOptions;

  }

  public isTransactionFee(tx: RawTransactionVerbose) {
    let x;
    if (tx.systx && this.asset.symbol === "SYS") {
      const vouts = tx.vout;
      if (vouts[0].assetInfo) {
        return "tokens.label_tx_tx_fee";
      }
    }
    return x;
  }

  async decorateUnconfirmedTransactions(pendingTxs) {
    const unconfirmedTxsFiltered = pendingTxs.map((txItem) => {
      // Avoid modifying store.
      const txn = { ...txItem.tx };
      switch (this.asset.baseChainSymbol) {
        case "AVAX":
        case "ETH":
          return this.appendDataToEVMTransaction(txn);
          break;
        case "SOL":
          return this.appendDataToTransactionSol(txn);
          break;
        default:
          return this.appendDataToTransaction(txn);
          break;
      }
    });

    this.unconfirmedTxs = unconfirmedTxsFiltered;
  }

  public goTranDetailsPage(txn) {
    const txSummary: TxSummary = {
      fromAddress: txn.fromAddress,
      toAddress: txn.toAddress,
      amount: txn.amount,
      time: txn.time || txn.blockTime,
      confirmations: txn.confirmations,
      txid: txn.txid || txn.hash,
      type: txn.type,
      tokenInfo: this.asset,
      systx: txn.systx,
      fee: txn.fee,
      memo: this.asset.baseChainSymbol === "ETH" ? "" : getTransactionMemo(txn),
      assetAllocFee: txn.systx && (this.asset.symbol !== "SYS" || this.isTransactionFee(txn)) ? 0.0000068 : null,
    };

    txSummary.memo = this.asset.baseChainSymbol === "ETH" ? "" : getTransactionMemo(txn);
    try {
      txSummary.auxFee = getAuxFeeFromTx(txn, this.asset.auxFeeAddress);
      txSummary.auxFeeAddress = this.asset.auxFeeAddress[0];
    } catch (err) {
      // not SPT/no auxfee set
      Logger.error('goTranDetailsPage', inspect(err));
    }

    if (txn.systx) {
      txSummary.auxFee = getAuxFeeFromTx(txn, this.asset.auxFeeAddress);
    }
    let navigationExtras: NavigationExtras = {
      state: {
        txnDetails: txSummary,
        tokenInfo: this.asset,
      },
    };
    this.router.navigate(["/vault-intro/tranDetails"], navigationExtras);
    // this.navCtrl.navigateForward(["/vault-intro/tranDetails"]);
  }
  public updateOptions(option: any): void {
    this.selectedDate = "";
    this.activeOptionButton = option;
    this.getWalletAssetGrowth(option);
    this.getAssetGrowth(option)
    switch (this.coinNature) {
      case 'holdings':
        this.chart.updateOptions(this.updateOptionsData[option], false, true, true);
        break;
      case 'price':
        this.chartMarket.updateOptions(this.updateOptionsData[option], false, true, true);
        break;
    }
  }

  getTimeSpanData(dataArray, dateValue) {
    if (dataArray && dataArray.length != 0) {
      var splitIndex = dataArray.findIndex(elem => elem[3] == dateValue)
      var timeSpanArray = dataArray.slice(splitIndex);

      if (splitIndex != -1 && timeSpanArray.length > 1) {
        if (timeSpanArray[0][1] != 0) {
          this.growthPercentage.percentage = (((timeSpanArray[timeSpanArray.length - 1][1] - timeSpanArray[0][1]) / timeSpanArray[0][1]) * 100).toFixed(3);
        } else {
          this.growthPercentage.percentage = 0
        }
        this.growthPercentage.amount = (timeSpanArray[timeSpanArray.length - 1][1] - timeSpanArray[0][1]).toFixed(3);
      } else {
        this.growthPercentage.percentage = 0;
        this.growthPercentage.amount = 0
      }
    }

  }

  getWalletAssetGrowth(timeRange) {
    switch (timeRange) {
      case '1D':
        this.getTimeSpanData(this.graphDataSet[this.asset.keyringId], moment.unix(moment().startOf("day").unix()).format("MMM DD YYYY"))
        break;
      case '1W':
        this.getTimeSpanData(this.graphDataSet[this.asset.keyringId], moment.unix(moment().subtract(7, "days").unix()).format("MMM DD YYYY"))
        break;
      case '1M':
        this.getTimeSpanData(this.graphDataSet[this.asset.keyringId], moment.unix(moment().subtract(1, "months").unix()).format("MMM DD YYYY"))
        break;
      case 'YTD':
        this.getTimeSpanData(this.graphDataSet[this.asset.keyringId], moment.unix(moment().startOf("year").unix()).format("MMM DD YYYY"))
        break;
      default:
        this.getTimeSpanData(this.graphDataSet[this.asset.keyringId], moment.unix(moment().subtract(1, "years").unix()).format("MMM DD YYYY"))
        break;
    }
  }

  resetChart() {
    this.activeOptionButton = "ALL";
    this.selectedDate = "";
    this.showholdingChart = false;
    this.initChart();
  }

  async decorateTransactions(transactions: any[]) {
    let result = transactions
      .map((tx) => JSON.parse(JSON.stringify(tx))) // clone txs, we don't want to modify store
      .filter((txn) => {
        if (this.asset.symbol === "ETH") {
          // Hide ERC20 txs in ETH history.
          return Number(txn.value);
        }

        return true;
      })
      .map((txItem) => {
        // Avoid modifying store.
        const txn = { ...txItem };
        switch (this.asset.baseChainSymbol) {
          case "AVAX":
          case "ETH":
            return this.appendDataToEVMTransaction(txn);
            break;
          case "SOL":
            return this.appendDataToTransactionSol(txn);
            break;
          default:
            return this.appendDataToTransaction(txn);
            break;
        }
      })
      .filter((txn) => txn.amount); // remove txs with amount === 0

    return result;
  }

  appendDataToTransactionSol(txn) {
    const txAmount = getTransactionAmountsByAddressSol(txn, this.walletAddress);
    txn.type = txAmount.type;
    txn.fromAddress = txn.from;
    txn.toAddress = txn.to;
    txn.amount = txAmount.totalValue;
    txn.avatar = txn.to;
    txn.fee = txn.fee;
    txn.time = txn.blockTime || Date.now();
    return txn;
  }

  appendDataToEVMTransaction(txn) {
    const txAmount = getTransactionAmountsByEVMAddress(txn, this.walletAddress);
    txn.type = txAmount.type;
    txn.fromAddress = txn.from;
    txn.toAddress = txn.to;
    txn.amount = txAmount.totalValue;
    txn.avatar = txn.to;
    txn.fee = txn.gasPrice * txn.gasUsed;
    txn.time = txn.timeStamp || Date.now();
    return txn;
  }

  async getWalletAddress() {
    const coinKeyring = await this.store
      .select(getTokenKeyring, {
        keyringId: this.asset.keyringId,
      })
      .first()
      .toPromise();
    return coinKeyring.address;
  }

  appendDataToTransaction(txn) {
    const txAmount = getTransactionAmountsByAddress(txn, this.walletAddress, this.asset.baseChainSymbol === "ETH");

    txn.type = txAmount.type;
    if (txn.type === "send") {
      txn.fromAddress = this.walletAddress;
      txn.toAddress = removeAuxFeeAddressFromArray(txAmount.voutAddresses, this.asset.auxFeeAddress || [])[0];
      txn.amount = getSendTypeValueFromtxAmount(txAmount, this.walletAddress, this.isBaseChain(), this.asset.guid);
      txn.avatar = txn.toAddress;
      txn.fee = txn.fees;
      txn.time = txn.blockTime;
    } else if (txn.type === "receive") {
      txn.amount = getReceiveTypeValueFromtxAmount(txAmount, this.walletAddress, this.isBaseChain(), this.asset.guid);
      txn.toAddress = this.walletAddress;
      txn.fromAddress = txAmount.vinAddresses[0];
      txn.avatar = txn.toAddress;
      txn.fee = txn.fees;
      txn.time = txn.blockTime;
    } else {
      // self
      txn.amount = txn.fee;
    }

    // SPT txs sends a small amount of SYS, that most likely will be in index 1 if the array is sorted
    // (0 = OP_RETURN, 1 = sys, X > 1 return)
    // txn.vout = txn.vout.sort((prev, next) => prev.value - next.value);
    txn.memo = getTransactionMemo(txn);

    return txn;
  }

  isBaseChain() {
    return this.asset.symbol === this.asset.baseChainSymbol;
  }

  goBack() {
    this.navCtrl.back();
  }
  segmentChanged(ev: any) {
    if (ev && ev.detail.value) {
      this.coinNature = ev.detail.value;
    }
    this.getAssetGrowth('ALL')
  }
  async doCopy() {
    await handleCopy(this.asset.address, this.platform, this.clipboard, this.alertController, this.translate, this.clipboardService, null);
  }

  async doSendAgain(tx: TransactionSummary, slidingItem: IonItemSliding) {
    const sendAgainAddress = tx.type === 'send' ? tx.toAddress : tx.fromAddress;
    this.openSendOrReceiveModal('send', sendAgainAddress)
    slidingItem.close();
  }

  async openSendOrReceiveModal(mode, sendAgainAddress?) {
    if (mode === "send") {
      const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
      let cssClass = "";
      cssClass += this.isDesktopMode ? "send-asset-modal-desktop" : "send-asset-modal";
      cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";
      const modal = await this.modalController.create({
        component: SendAssetModal,
        componentProps: {
          baseToken: this.asset?.baseChainSymbol,
          guid: this.asset?.guid,
          coinLogo: this.asset?.logo,
          tokenInfo: this.asset,
          sendAgainAddress: sendAgainAddress
        },
        cssClass,
        backdropDismiss: false,
        id: "sendAssetModal",
      });
      await modal.present();
    } else {
      const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
      let cssClass = "";
      cssClass += this.isDesktopMode ? "send-asset-modal-desktop" : "send-asset-modal";
      cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";
      const modal = await this.modalController.create({
        component: ReceiveAssetModal,
        componentProps: {
          tokenInfo: this.asset,
        },
        cssClass,
      });
      return await modal.present();
    }
  }
  async buyAsset() {
    this.modalController.dismiss();
    var kycData = await this.complianceService.getKycCip();
    if (!kycData["passingLevel"]) {
      const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
      await openKycModal(sideMenuHidden, this.isDesktopMode, this.modalController);
      return;
    } else {
      const cssClass = (this.isDesktopMode) ? 'select-asset-modal-desktop' : 'select-asset-modal';
      const modal = await this.modalController.create({
        component: SelectPaymentModal,
        componentProps: {
          selectedToken: this.asset.symbol,
          selectedTokenAddress: this.asset.address,
          symbol: this.asset.symbol,
          selectedFromVault: true
        },
        id: 'select-payment-model',
        cssClass,
        backdropDismiss: false,
        initialBreakpoint: (this.isDesktopMode) ? undefined : 0.9,
        breakpoints: (this.isDesktopMode) ? undefined : [0, 0.6, 0.9, 1],
      });
      await modal.present();
    }
  }
  async openTokenInfo() {
    this.modalController.dismiss();
    await presentAlert(
      this.alertController,
      this.translate,
      null,
      'coin_info.header',
      this.asset.coinInfo,
      'btn_back',
      { coinName: this.asset.name }
    );
  }

  async copyAddress(item, slidingItem: IonItemSliding) {
    const address = item.type == "send" ? item.toAddress : item.fromAddress;
    await handleCopy(address, this.platform, this.clipboard, this.alertController, this.translate, this.clipboardService, null);
    slidingItem.close();

  }
}
